module.exports = __webpack_public_path__ + "static/media/Relaxation Meditation Songs Divine - Свтло на вод.f6a8a226.mp3";